import { render, staticRenderFns } from "./EditarUnidade.vue?vue&type=template&id=cdf0b4bc&"
import script from "./EditarUnidade.vue?vue&type=script&lang=js&"
export * from "./EditarUnidade.vue?vue&type=script&lang=js&"
import style0 from "./EditarUnidade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports